import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const MEMBER_DELETE_TASK: BuiltInTaskDefinition = {
    slug: 'member-delete',
    name: 'Remove a member from a conversation',
    kind: 'llm',
    overlapPolicy: 'skip',
    concurrencySafe: true,
    serializeOn: null,
    builtInRole: 'org_change',
    chatPurpose: null,
    goal: 'Name the roles and tasks a member’s removal leaves without a holder, write the removal as a plan, and get the CEO’s sign-off; the OS removes the member at their approval unless they have work in flight',
    metric: {
        text: 'Share of member-removal sign-offs that name every role and task losing its holder before the CEO decides',
    },
    guardrails: [
        'Propose only — write the plan with os.write_plan; the OS removes the member once the CEO approves, and refuses while they have work in flight',
        'Name every role the member is the only holder of, and every task that loses its holder, before asking for sign-off',
        'A member only, by memberId or memberHandle: never a person’s account',
    ],
    inputs: [
        {
            key: 'request',
            label: 'What the CEO wants removed',
            type: 'string',
            required: true,
        },
        {
            key: 'ceoNote',
            label: 'CEO note from a previous round',
            type: 'string',
            required: false,
        },
        {
            key: 'chatSessionId',
            label: 'Chat session this plan belongs to (chat fills it)',
            type: 'string',
            required: false,
        },
        {
            key: 'planKey',
            label: 'The conversation this plan belongs to when it has no chat session (the OS fills it)',
            type: 'string',
            required: false,
        },
    ],
    tools: ['os.directory', 'os.write_plan', 'os.read_plan', 'os.ask_ceo'],
    gates: [
        {
            tool: 'os.ask_ceo',
            owner: 'ceo',
            approval: 'specific',
        },
    ],
    spend: {
        moneyUsdPerRun: 1.5,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'member-delete',
            on: 'ceo_approved',
            resumeConversation: true,
        },
        {
            slug: 'member-delete',
            on: 'ceo_changes_requested',
        },
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    skillMd: TASK_TEXT['member-delete.md'],
    adapterMd: TASK_TEXT['member-delete.adapter.md'],
}
